enum MarkerType {
  TEAM_MEMBER = 'teamMember',
  CLIENT = 'client',
  CRISIS_ALERT = 'crisisAlert',
  CRISIS_TEAM_MEMBER = 'crisisTeamMember',
  CRISIS_TEAM_MEMBER_ALLOCATED = 'crisisTeamMemberAllocated',
  CRISIS_TEAM_MEMBER_VISIT_STARTED = 'crisisTeamMemberVisitStarted',
  CRISIS_ALLOCATED_CLIENT = 'crisisAllocatedClient',
}

export default MarkerType;
